import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useMotionValue, useTransform } from "framer-motion";
import styles from "./ServiceCard.module.css";

const ServiceCard = ({
  id,
  title,
  description,
  icon: IconComponent,
  bgImage,
}) => {
  const cardRef = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const rotateX = useTransform(y, [-100, 100], [8, -8]);
  const rotateY = useTransform(x, [-100, 100], [-8, 8]);

  const bgX = useTransform(x, [-100, 100], ["-10%", "10%"]);
  const bgY = useTransform(y, [-100, 100], ["-10%", "10%"]);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const mouseX = e.clientX - centerX;
    const mouseY = e.clientY - centerY;
    x.set(mouseX);
    y.set(mouseY);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  const backgroundImage =
    bgImage ||
    "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&auto=format";

  return (
    <Link to={`/services/${id}`} className={styles.cardLink}>
      <motion.div
        ref={cardRef}
        className={styles.card}
        style={{
          rotateX,
          rotateY,
          transformStyle: "preserve-3d",
          backgroundImage: `url(${backgroundImage})`,
          backgroundPosition: `${bgX.get()} ${bgY.get()}`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        whileHover={{ scale: 1.02 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      >
        <div className={styles.overlay}></div>
        <div className={styles.content}>
          <div className={styles.icon}>
            <IconComponent />
          </div>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
        </div>
      </motion.div>
    </Link>
  );
};

export default ServiceCard;
